"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeStencilComponent = composeStencilComponent;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _testAttributes = require("./testAttributes");
function composeStencilComponent(_ref) {
  let {
    baseComponent,
    displayName,
    description,
    defaultProps,
    propTypes
  } = _ref;
  // Wrapping base component with describe HoC.
  const ComponentWithDocs = (0, _stencilReactDesc.describe)(baseComponent).description(description);

  // Adding prop-types with description
  if (propTypes) {
    ComponentWithDocs.propTypes = {
      ...propTypes
    };
  }

  // Adding defaultProps values
  if (defaultProps) {
    ComponentWithDocs.defaultProps = {
      ...defaultProps
    };
  }

  // Adding test attributes (data-test-component, data-test-id)
  const Component = (0, _testAttributes.withTestAttributes)({
    component: "Stencil".concat(displayName)
  })(ComponentWithDocs);

  // Naming components
  Component.displayName = displayName;
  ComponentWithDocs.displayName = "described(".concat(displayName, ")");
  return Component;
}